const Notfound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        textAlign: "center",
      }}
    >
      <img
        src={require("../assets/images/404error.png")}
        alt="404 Error"
        style={{ width: "200px", height: "auto" }}
      />

      <h1>404 Not Found</h1>
      <p>The page you're looking for does not exist.</p>

      <button
        onClick={() => (window.location.href = "/")}
        style={{
          marginTop: "20px",
          padding: "10px 22px",
          backgroundColor: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: "500",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#0000cc";
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#0000EE";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        Return Home
      </button>
    </div>
  );
};

export default Notfound;